import { useEffect } from "react";
import { calcPrefillFields } from "@/lib/booking-api";

// Applies calculator quick-quote data onto the booking form when it arrives.
export function useCalcPrefill(prefill, t, setForm) {
  useEffect(() => {
    if (!prefill) return;
    setForm((prev) => ({ ...prev, ...calcPrefillFields(prefill, t) }));
  }, [prefill, t, setForm]);
}
